import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Card, InputNumber, Radio } from "antd";
import React from "react";


const BillingHistory = (props) => {

    return <Card className="billing-card">
    <div className="billing_content">
        <div className="card-heading">
          Billing History
        </div>
        <div className="content_item">
          <div className="billing_cards">
            <label className="bill_date">December 2, 2023</label>
            <div className="bill_plan">Food Truck Plan.</div>
            <label className="atm_info">Visa ending 8673</label>
            <div className="view_link">VIEW RECEIPT</div>
          </div>
          <div className="billing_cards">
            <label className="bill_date">December 2, 2023</label>
            <div className="bill_plan">Food Truck Plan.</div>
            <label className="atm_info">Visa ending 8673</label>
            <div className="view_link">VIEW RECEIPT</div>
          </div>
        </div>
    </div>
  </Card>
};
export default BillingHistory;